var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.891,
    height: 23.891,
    viewBox: "0 0 23.891 23.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_dashboard_1359719",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M17.435,6.49A10.945,10.945,0,1,0,28.381,17.435,10.945,10.945,0,0,0,17.435,6.49Zm0,21.382a10.44,10.44,0,1,1,0,.005Z",
    transform: "translate(-6.49 -6.49)",
    fill: "#a0a0a0",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 0.503,
    height: 3.187,
    transform: "translate(10.694 2.058)",
    fill: "#a0a0a0",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 3.187,
    height: 0.503,
    transform: "translate(16.648 10.694)",
    fill: "#a0a0a0",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 3.187,
    height: 0.503,
    transform: "translate(2.058 10.694)",
    fill: "#a0a0a0",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 0.503,
    height: 3.187,
    transform: "translate(4.481 4.84) rotate(-45)",
    fill: "#a0a0a0",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M49.884,24.665l-.355-.355-4.744,4.744a2.2,2.2,0,1,0,.355.355Zm-6.463,7.8a1.693,1.693,0,1,1,1.693-1.693A1.693,1.693,0,0,1,43.422,32.466Z",
    transform: "translate(-32.477 -19.827)",
    fill: "#a0a0a0",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.c0dcea7ed9513a6a48df6faada090935.svg";
export { ForwardRef as ReactComponent };